import React from 'react';
import Background from './components/background';
import Foreground from './components/foreground';
import TopHeader from './components/topHeader';


function App() {
  return (
    <div style={{ width: '100vw', height: '700vh' }}>
      <TopHeader />
      <Background />
      <Foreground />
      {}
    </div>
  );
}

export default App;
